module.exports = __webpack_public_path__ + "img/8d208ce.webp";